import LogoJcb from "@assets/tarjetas/JCB.png";
import LogoAmex from "@assets/tarjetas/amex.png";
import LogoDiners from "@assets/tarjetas/diners.png";
import LogoDiscover from "@assets/tarjetas/discover.png";
import LogoMasterCard from "@assets/tarjetas/masterCard.png";
import LogoVisa from "@assets/tarjetas/visa.png";
import duration from "dayjs/plugin/duration";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { RolesENUM } from "../constants";
import {
  BeneficiosValues,
  CreditCardType,
  IPromocion,
  MaterialTransferido,
  PaymentMethodEnum,
  PlanificadorEvent,
  TimeMapPlanificador,
  TreeNode,
} from "../interfaces";
import { EmpleadoColor } from "../interfaces/erp/empleados";
import { IHorasDisponibles } from "../interfaces/erp/system-settings/horas-libres-flota.interface";
import { formatDate } from "./format-date";
import dayjs, { } from 'dayjs';
import { toast } from "react-toastify";

dayjs.extend(duration);

export function calcularEdad(fechaNacimiento: string): number {
  const hoy = dayjs();
  const nacimiento = dayjs(fechaNacimiento, "YYYY-MM-DD");

  // Calcula la edad en años
  let edad = hoy.diff(nacimiento, "year");

  const cumpleEsteAno = nacimiento.add(edad, "years");
  if (hoy.isBefore(cumpleEsteAno)) {
    edad -= 1;
  }

  return edad;
}

export function a11yProps(index: number | string) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export function calcularDiferenciaDeTiempo(
  horaInicio: string,
  horaFin: string
) {
  const [hInicio, mInicio, sInicio] = horaInicio.split(":").map(Number);
  const [hFin, mFin, sFin] = horaFin.split(":").map(Number);

  const fechaInicio = new Date(1970, 0, 1, hInicio, mInicio, sInicio);
  const fechaFin = new Date(1970, 0, 1, hFin, mFin, sFin);

  const diferenciaEnMilisegundos = fechaFin.getTime() - fechaInicio.getTime();
  const diferenciaEnSegundos = diferenciaEnMilisegundos / 1000;
  //const diferenciaEnMinutos = diferenciaEnSegundos;

  return diferenciaEnSegundos;
}

export function horaActualSistema() {
  const formatoHora = new Intl.DateTimeFormat("es-EC", {
    timeZone: "America/Guayaquil",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
  });

  const partesHora = formatoHora.formatToParts(new Date());
  const horaFormateada = partesHora
    .map((parte) =>
      parte.type === "literal" ? parte.value : parte.value.padStart(2, "0")
    )
    .join("");

  return horaFormateada;
}

export const subtractHundredYears = (): string => {
  const currentDate = new Date();
  const hundredYearsAgo = new Date(currentDate);

  hundredYearsAgo.setFullYear(currentDate.getFullYear() - 100);

  const year = hundredYearsAgo.getFullYear();
  const month = String(hundredYearsAgo.getMonth() + 1).padStart(2, "0"); // Meses van de 0 a 11, por lo que se suma 1
  const day = String(hundredYearsAgo.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

// Definir una función para obtener la ubicación
interface Coordinates {
  latitude: number;
  longitude: number;
}

export function obtenerUbicacion(): Promise<Coordinates> {
  return new Promise((resolve, reject) => {
    // Verificar si el navegador soporta la API de Geolocalización
    if (!navigator.geolocation) {
      reject(
        new Error(
          "La API de Geolocalización no es soportada por este navegador."
        )
      );
      return;
    }

    // Obtener la ubicación actual
    try {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };

          resolve(coords);
        },
        (err) => {
          console.log(err);

          switch (err.code) {
            case err.PERMISSION_DENIED:
              toast.info(
                "El permiso de ubicación fue denegado. Actívalo desde la configuración del navegador para continuar."
              );
              break;
            case err.POSITION_UNAVAILABLE:
              toast.info(
                "No se pudo obtener la ubicación. Es posible que el dispositivo no tenga señal o que los servicios de localización estén deshabilitados."
              );
              break;
            case err.TIMEOUT:
              toast.info("La solicitud de ubicación ha expirado.");
              break;
            default:
              toast.info("Error desconocido al obtener la ubicación.");
              break;
          }

          reject(new Error("No se pudo obtener la ubicación: " + err.message));
        }
      );
    } catch (error) { }
  });
}

export const removeLeadingZero = (num: string): string => {
  const cleanedCode = num.replace(/(?:^|(?<=\.))0+(\d+)/g, "$1");
  const trimmedCode = cleanedCode.trim().replace(/\.$/, "");
  return trimmedCode;
};

export const fnPasarevision = (formaPago: string) => {
  if (
    formaPago == PaymentMethodEnum.DEBITO ||
    formaPago == PaymentMethodEnum.TARJETA
  ) {
    return true;
  }
  //existe rubro de instalación
  return false;
};

export function convertirFormatoHora(numero: number) {
  const horas = Math.floor(numero);
  const minutos = Math.round((numero - horas) * 60); // Convierte el decimal a minutos directamente

  const hora = dayjs().hour(horas).minute(minutos);
  return hora.format("HH:mm");
}

dayjs.extend(utc);
dayjs.extend(timezone);

export function calcularTiempoMaxLimite(tiempo: number): string {
  const zonaHorariaEcuador = "America/Guayaquil";
  const horaActualEcuador = dayjs().tz(zonaHorariaEcuador);
  const horaConSuma = horaActualEcuador.add(tiempo, "minute");

  // Retorna la hora en formato de 24 horas 'HH:mm:ss'
  return horaConSuma.format("HH:mm:ss");
}

export function encontrarNoCoincidencias(
  arrayA: string[],
  arrayB: string[]
): string[] {
  const noCoincidencias: string[] = [];
  // Buscar en arrayB
  for (const serieB of arrayB) {
    let coincide = false;
    for (const serieA of arrayA) {
      if (serieB === serieA) {
        coincide = true;
        break;
      }
    }
    if (!coincide) {
      noCoincidencias.push(serieB);
    }
  }
  return noCoincidencias;
}

export const limpiarProductosInventario = (
  ingresoProductos: MaterialTransferido[]
) => {
  const aux = ingresoProductos.map((item) => ({
    ...item,
    cantidad: item.cantidad.toString(),
  }));

  return aux;
};

export const flattenChildren = (nodes: TreeNode[]) => {
  let result: TreeNode[] = [];

  const traverse = (node: TreeNode) => {
    if (node.children) {
      node.children.forEach((child) => {
        result.push({ ...child, children: [] });
        traverse(child);
      });
    }
  };

  nodes.forEach((node) => {
    result.push({ ...node, children: [] });
    traverse(node);
  });

  return result;
};

export const findObjectById = (
  array: TreeNode[],
  id: string
): TreeNode | null => {
  for (const item of array) {
    if (item.id === id) {
      return item;
    }
    if (item.children && item.children.length > 0) {
      const found = findObjectById(item.children, id);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

export const getNextInSeries = (previous: string): string => {
  const parts = previous.split(".");

  // Incrementar el último componente
  const lastPart = parts.pop();
  if (lastPart === undefined) {
    throw new Error("Invalid series format");
  }
  const incrementedPart = (parseInt(lastPart, 10) + 1).toString();

  // Volver a ensamblar la cadena con el componente incrementado
  parts.push(incrementedPart);
  return parts.join(".");
};

export const validateEcuadorianID = (id: string): boolean => {
  // Verificar que la cédula tenga exactamente 10 dígitos
  if (!/^\d{10}$/.test(id)) {
    return false;
  }

  // Extraer los primeros 9 dígitos como un array de números
  const digits = id.split("").map(Number);
  const provinceCode = Number(id.substring(0, 2));
  const thirdDigit = digits[2];

  // Verificar que el código de provincia esté en el rango permitido (1-24)
  if (provinceCode < 1 || provinceCode > 24) {
    return false;
  }

  // Verificar que el tercer dígito sea menor que 6 (para cédulas de personas naturales)
  if (thirdDigit >= 6) {
    return false;
  }

  // Calcular el dígito verificador
  const coefficients = [2, 1, 2, 1, 2, 1, 2, 1, 2];
  const sum = digits.slice(0, 9).reduce((acc, digit, index) => {
    let product = digit * coefficients[index];
    if (product > 9) {
      product -= 9;
    }
    return acc + product;
  }, 0);

  const verifierDigit = (10 - (sum % 10)) % 10;

  // Verificar que el dígito verificador calculado coincida con el último dígito de la cédula
  return verifierDigit === digits[9];
};

export const checkTimePassed = (
  date: string,
  time: string,
  hora_incio: string
): string => {
  const today = formatDate(new Date());

  if (hora_incio) return "green";

  if (dayjs(date) > dayjs(today)) return "none"; //fechas futuras

  if (dayjs(date) < dayjs(today) && !hora_incio) return "red";

  const [hours, minutes, seconds] = time.split(":");
  const now = dayjs();
  const inputTime = dayjs()
    .hour(parseInt(hours))
    .minute(parseInt(minutes))
    .second(parseInt(seconds));

  const diffInMinutes = now.diff(inputTime, "minute");

  if (diffInMinutes >= 30) {
    return "red";
  } else if (diffInMinutes >= 15) {
    return "orange";
  }
  return "none";
};

export function obtenerPromocionDePrioridadMasBaja(promociones: IPromocion[]) {
  if (promociones.length === 0) {
    return null; // Retorna null si el array está vacío
  }

  return promociones.reduce((prev, current) => {
    return prev.prioridad < current.prioridad ? prev : current;
  });
}

const generarHash = (id: string): number => {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
};

// Función para convertir el hash en un color hexadecimal
const convertirHashAColor = (hash: number): string => {
  const color = (hash & 0x00ffffff).toString(16).toUpperCase();
  return `#${"00000".substring(0, 6 - color.length)}${color}`;
};

// Función para obtener un color único basado en el ID de usuario
export const obtenerColorPorUsuario = (userId: string): string => {
  const hash = generarHash(userId);
  return convertirHashAColor(hash);
};

type IVerificarHoras = {
  valido: boolean;
  arrayHoras: number[];
  idPreventa?: string | null;
};
export function verificarHoras(
  arrayObjetos: IHorasDisponibles[],
  horaSelect: number
): IVerificarHoras {
  ///* Bloqueo de 2:30 min
  const arrayHoras = [
    horaSelect,
    horaSelect + 0.5,
    horaSelect + 1,
    horaSelect + 1.5,
    horaSelect + 2,
  ];

  let arrayAux: IHorasDisponibles[] = [];

  arrayObjetos.forEach((value) => {
    if (arrayHoras.find((e) => e == value.hora)) {
      arrayAux.push(value);
    }
  });

  return {
    idPreventa: arrayAux.filter((e) => e.id_preventa != null).at(0)
      ?.id_preventa,
    valido: arrayHoras.every((hora) =>
      arrayObjetos.some((objeto) => objeto.hora === hora)
    ),
    arrayHoras: arrayHoras,
  };
}

export function convertirFormatoHoraArray(arrayHoras: number[]): string[] {
  const aux = arrayHoras.map((value) => {
    const horas = Math.floor(value);
    const minutos = Math.round((value - horas) * 60); // Convierte el decimal a minutos directamente

    const hora = dayjs().hour(horas).minute(minutos);
    return hora.format("HH:mm");
  });

  return aux;
}

export function convertirHoraIntervalo30Minutos() {
  const now = dayjs(); // Obtener la hora actual
  const horas = now.hour(); // Obtener las horas actuales
  const minutos = now.minute(); // Obtener los minutos actuales

  const intervalo = minutos < 30 ? 0 : 0.5;

  const horaDecimal = horas + intervalo; // Sumar horas con los minutos redondeados

  return horaDecimal;
}

export function convertirHoraADecimalArray(hora: string): number[] {
  const time = dayjs(hora, "HH:mm:ss"); // Parsear la hora en formato "HH:mm:ss"
  const horas = time.hour(); // Obtener las horas
  const minutos = time.minute(); // Obtener los minutos

  // Convertir los minutos a fracción de hora
  const minutosDecimal = minutos / 60;

  const horaDecimal = horas + minutosDecimal;

  const arrayHoras = [
    horaDecimal,
    horaDecimal + 0.5,
    horaDecimal + 1,
    horaDecimal + 1.5,
    horaDecimal + 2,
  ];

  // Sumar las horas con los minutos en formato decimal
  return arrayHoras;
}

export function obtenerSegundosEntreFechas(fechaObjetivo: string): number {
  const fechaActual = dayjs(); // Fecha y hora actual
  const fechaFinal = dayjs(fechaObjetivo, "YYYY-MM-DD HH:mm:ss"); // Convertir la fecha en formato válido

  // Calcular la diferencia en minutos
  const diferenciaEnMinutos = fechaFinal.diff(fechaActual, "second");

  return diferenciaEnMinutos;
}

export function calcularSegundosHoraSeleccionada(pastTime: string) {
  // Obtener la hora actual
  const now = dayjs();

  // Crear un objeto dayjs con la hora pasada (hoy)
  const [hours, minutes, seconds] = pastTime.split(":").map(Number);
  const past = dayjs()
    .set("hour", hours)
    .set("minute", minutes)
    .set("second", seconds);

  // Calcular la diferencia en segundos
  const differenceInSeconds = now.diff(past, "second");

  return differenceInSeconds;
}

export const transformarAEventosFullCalendar = (
  data: TimeMapPlanificador[],
  empladoColor: EmpleadoColor[]
): PlanificadorEvent[] => {
  return data.flatMap(({ fecha, horas }) => {
    return horas
      .filter(({ hora }) => hora >= 0 && hora < 23.5) // Filtra las horas válidas
      .map(
        ({ hora, estado, historial, fecha_hora_limite, motivo, ...rest }) => {
          const start = dayjs(
            `${fecha} ${Math.floor(hora)}:${(hora % 1) * 60}`
          );
          const end = start.add(30, "minute");

          const username = historial?.at(-1)?.user || null;

          const color = empladoColor.find((e) => e.username == username)?.color;

          return {
            title: estado ? "Ocupado" : "Libre",
            textColor: estado ? "white" : "black",
            //backgroundColor: existe ? empladoColor.find(e => e.username == username)?.color : 'transparent',
            backgroundColor: estado
              ? color
                ? color
                : "#6366F1"
              : "transparent",
            start: start.format("YYYY-MM-DDTHH:mm:ss"),
            end: end.format("YYYY-MM-DDTHH:mm:ss"),
            hora,
            estado,
            username,
            motivo: motivo,
            ...rest,
          };
        }
      );
  });
};

export const fnMostrarTipoTarjeta = (tipo: string | null): string => {
  switch (tipo) {
    case CreditCardType.VISA:
      return LogoVisa;
    case CreditCardType.DISCOVER:
      return LogoDiscover;
    case CreditCardType.MASTERCARD:
    case CreditCardType.MAESTRO:
      return LogoMasterCard;
    case CreditCardType.AMERICANEXPRESS:
      return LogoAmex;
    case CreditCardType.DINERSCLUB:
      return LogoDiners;
    case CreditCardType.JCB:
      return LogoJcb;
    default:
      return "";
  }
};

export const calcularTiempoTranscurrido = (
  isoDate: string
): { texo: string; color: string } => {
  const fechaInicio = dayjs(isoDate);
  const fechaActual = dayjs();

  if (!fechaInicio.isValid()) {
    throw new Error(
      "Fecha no válida. Asegúrate de que esté en formato ISO 8601."
    );
  }

  const diferencia = fechaActual.diff(fechaInicio);
  const duracion = dayjs.duration(diferencia);

  const dias = duracion.days();
  const horas = duracion.hours();
  const minutos = duracion.minutes();

  if (dias == 0 && horas == 0) {
    if (minutos <= 10) {
      return {
        texo: `Ultima gestión en 10 minutos.`,
        color: "blue",
      };
    }
    if (minutos > 10 && minutos <= 25) {
      return {
        texo: `Ultima gestión en 10 y 25 minutos.`,
        color: "orange",
      };
    }
    if (minutos > 25 && minutos <= 40) {
      return {
        texo: `Ultima gestión en 25 y 40 minutos.`,
        color: "red",
      };
    }
  }

  return {
    texo: `Tiempo transcurido ${dias} días, ${horas} horas, ${minutos} minutos`,
    color: "#1D1616",
  };
};

export const toHour = (numero: number) =>
  numero % 1 === 0.5 ? `${Math.floor(numero)}:30` : `${numero}:00`;

export const handleTipoUsuario = (rol: string): string => {
  switch (rol) {
    case RolesENUM.SUPERVISOR:
      return "COORDINADOR";
    case RolesENUM.ADMINISTRATIVO:
      return "PLANEACION Y LOGISTICA";
    case RolesENUM.AGENTE:
      return "ASESOR";
    default:
      return "N/A";
  }
};

export const horaToNumero = (hora: string): number => {
  const [hh, mm] = hora.split(":").map(Number);
  return hh + mm / 60; // Convierte los minutos a fracción de hora
};

/* export const esFechaFutura = (fecha: string): boolean => {
  const fechaIngresada = new Date(fecha);
  const fechaActual = new Date();

  // Normaliza la fecha actual a medianoche para evitar diferencias de horas
  fechaActual.setHours(0, 0, 0, 0);

  return fechaIngresada > fechaActual;
}; */

export const esFechaHoraFutura = (fecha: string, hora: string): boolean => {
  const fechaIngresada = new Date(`${fecha}T${hora}`);
  const fechaActual = new Date();

  return fechaIngresada > fechaActual;
};


export function getDateOfCurrentWeek(dayNumber: number): Date {
  if (dayNumber < 1 || dayNumber > 7) {
    throw new Error('dayNumber debe estar entre 1 (lunes) y 7 (domingo)');
  }

  const now = new Date();
  // getDay: 0=domingo, 1=lunes, …, 6=sábado
  const currentJsDay = now.getDay();
  // isoDay: 1=lunes, …, 7=domingo
  const currentIsoDay = currentJsDay === 0 ? 7 : currentJsDay;

  // Calculamos la fecha del lunes de esta semana:
  // restamos (currentIsoDay - 1) días a 'now'
  const monday = new Date(now);
  monday.setDate(now.getDate() - (currentIsoDay - 1));

  // A partir de ese lunes, avanzamos (dayNumber - 1) días
  const target = new Date(monday);
  target.setDate(monday.getDate() + (dayNumber - 1));

  return target;
}


export enum ReglasSolicitudBeneficioEnum {
  REPORTADA_TELCO = 'REPORTADA TELCO',
  SCORE_BAJO = 'SCORE BAJO',
  FAMILIAR_DISCAPACIDAD = 'CUIDADO DE PERSONA CON DISCAPACIDAD',
  BONO_DESARROLLO_HUMANO = 'USUARIO DEL BONO DE DESARROLLO HUMANO',
  APLICA_GREMIO = 'APLICA GREMIO',
  AYUDA_SOCIAL = 'AYUDA SOCIAL'
}

const reglasSolicitudBeneficio: Array<[keyof BeneficiosValues, string]> = [
  ["reportado", ReglasSolicitudBeneficioEnum.REPORTADA_TELCO],
  ["es_reportado", ReglasSolicitudBeneficioEnum.SCORE_BAJO],
  ["es_tutor", ReglasSolicitudBeneficioEnum.FAMILIAR_DISCAPACIDAD], // solicitud
  ["es_bono_humano", ReglasSolicitudBeneficioEnum.BONO_DESARROLLO_HUMANO],
  ["es_gremio", ReglasSolicitudBeneficioEnum.APLICA_GREMIO],
  ["es_ayuda_social", ReglasSolicitudBeneficioEnum.AYUDA_SOCIAL],
  //["reportado", "REPORTADA POR EQUIFAX O TIENE SCORE BAJO"],
  //["es_curador_tutor", "CUIDADO DE PERSONA CON DISCAPACIDAD"], // prospecto
];

export function getSolicitudBeneficioLabel(values: BeneficiosValues): string {
  const regla = reglasSolicitudBeneficio.find(([k]) => values[k]);
  return regla?.[1] ?? "SOLICITUD DE BENEFICIO";
}


export function matchSegmentEquifax(
  grupos: string[] | undefined | null,
  segmento: string | undefined | null
): boolean {
  if (!grupos || !segmento) return false;
  const set = new Set(grupos.map(s => s.trim().toLowerCase()));
  return set.has(segmento.trim().toLowerCase());
}

export function getPrevAndNextDay(date: string) {
  const d = dayjs(date);

  const previousDay = d.subtract(1, 'day');
  const nextDay = d.add(1, 'day');

  return {
    previousDay,
    nextDay,
    previousDayStr: previousDay.format('YYYY-MM-DD'),
    nextDayStr: nextDay.format('YYYY-MM-DD'),
  };
}

export function mapSeriesToSeriesMetros(items: MaterialTransferido[]): MaterialTransferido[] {
  return items.map((item) => {
    if (!item.usa_metros) return item;

    const originalMap = item.series_metros ?? {};
    const newSeriesMetros: Record<string, string> = {};

    item.series!.forEach((serieCompleta) => {
      // Primero buscar por la serie completa
      let metros = originalMap[serieCompleta];

      // Si no encuentra, buscar por la base (sin el sufijo SUB-xxx)
      if (metros === undefined) {
        const basePart = serieCompleta.split('SUB')[0];
        const base = basePart.replace(/-$/, '');
        metros = originalMap[base];
      }

      if (metros !== undefined) {
        newSeriesMetros[serieCompleta] = metros;
      }
    });

    const cantidad_metros = Object.values(newSeriesMetros ?? {}).reduce((total, valor) => total + Number(valor), 0);

    return {
      ...item,
      cantidad_metros: cantidad_metros.toString(),
      series_metros: newSeriesMetros,
    };
  });
}

// Devolvemos undefined (no null) para que sea compatible con tipos de
// query params que esperan string | undefined (ej. tipo_orden_servicio).
// Si el caller necesita null, puede normalizarlo despues.
export const sanitizeTodos = (value: string | null | undefined): string | undefined =>
  value === 'TODOS' || value === null ? undefined : value;


export function diffDaysLabel(startDate: string, endDate: string): string {
  const start = dayjs(startDate, "YYYY-MM-DD", true);
  const end = dayjs(endDate, "YYYY-MM-DD", true);

  if (!start.isValid() || !end.isValid()) {
    throw new Error("Formato de fecha inválido. Use YYYY-MM-DD");
  }

  const days = end.diff(start, "day");
  const abs = Math.abs(days);

  const label = abs === 1 ? "Dia" : "Dias";
  return `${days} ${label}`;
}
export function arrayToRecordBy<T>(
  items: T[],
  getKey: (item: T) => string
): Record<string, T> {
  return items.reduce<Record<string, T>>((acc, item) => {
    acc[getKey(item)] = item;
    return acc;
  }, {});
}

export function stableStringify(obj: unknown): string {
  const seen = new WeakSet<object>();

  return JSON.stringify(obj, function (_key, value) {
    if (value && typeof value === "object") {
      if (seen.has(value)) return; // evita ciclos
      seen.add(value);

      if (Array.isArray(value)) return value;

      // ordena claves para estabilidad
      return Object.keys(value)
        .sort()
        .reduce<Record<string, unknown>>((acc, k) => {
          acc[k] = (value as Record<string, unknown>)[k];
          return acc;
        }, {});
    }
    return value;
  });
}

export function completarHorasFaltantes(data: IHorasDisponibles[]): IHorasDisponibles[] {
  if (!data.length) return [];

  const minHora = Math.min(...data.map(item => item.hora * 2));
  const maxHora = Math.max(...data.map(item => item.hora * 2));
  //const minHora = 7 * 2
  //const maxHora = 21 * 2

  //const minHora = 0 * 2
  //const maxHora = 24 * 2

  const mapaOriginal = new Map<number, IHorasDisponibles>();
  for (const item of data) {
    mapaOriginal.set(item.hora * 2, item);
  }

  const resultado: IHorasDisponibles[] = [];

  for (let h = minHora; h <= maxHora; h++) {
    if (mapaOriginal.has(h)) {
      resultado.push(mapaOriginal.get(h)!);
    } else {
      resultado.push({
        hora: h / 2,
        estado: true,
        motivo: null,
        id_user: null,
        id_preventa: null,
        fecha_hora_limite: null
      });
    }
  }

  return resultado.sort((a, b) => a.hora - b.hora);
}


export function toHours(number: number): number[] {
  return [
    number,
    number + 0.5,
    number + 1,
    number + 1.5,
    number + 2
  ]
}

export function containsAllHorasFast(
  a: { hora: number }[],
  b: number[]
): boolean {
  const horas = new Set(a.map(item => item.hora));
  return b.every(hora => horas.has(hora));
}

// Valida si hay duplicados en un array de strings

interface DuplicateCheckResult {
  existe_duplicados: boolean;
  valores_duplicados: string[];
}

export function getDuplicates(items: string[]): DuplicateCheckResult {
  const seen = new Set<string>();
  const duplicates = new Set<string>();

  for (const item of items) {
    // Normalizar: quitar espacios exteriores y pasar a minúsculas
    const normalized = item.trim().toLowerCase();

    if (seen.has(normalized)) {
      duplicates.add(normalized);
    } else {
      seen.add(normalized);
    }
  }

  const duplicatesArray = Array.from(duplicates);

  return {
    existe_duplicados: duplicatesArray.length > 0,
    valores_duplicados: duplicatesArray,
  };
}


export function tieneAlMenosUnCampoConValor<T extends object>(
  payload: T,
  campos: (keyof T)[]
): boolean {
  return campos.some((campo) => {
    const valor = payload[campo];
    return valor !== undefined && valor !== null && valor !== '';
  });
}